import { AppRoute } from '@app/core/routing/AppRoute';
import { RouteChildrenProps, Switch } from 'react-router-dom';

import { AdminVideoAnalysisPage } from './AdminVideoAnalysisPage';

export function AdminVideoAnalysisRoutes(props: RouteChildrenProps) {
  const { path } = props.match!;

  return (
    <Switch>
      <AppRoute path={`${path}`} component={AdminVideoAnalysisPage} />
    </Switch>
  );
}
